<div
  class="component-container"
  data-cy="won_message"
  [style.backgroundColor]="config().backgroundColor"
  [style.backgroundImage]="config().backgroundImage | transformUrl"
>
  <p
    class="completed-msg"
    [style.color]="config().completedMsg.color"
    [style.fontFamily]="config().completedMsg.fontFamily"
  >
    {{ config().completedMsg.text }}
  </p>

  <div class="reward-container">
    <p
      class="reward-msg"
      [style.fontFamily]="config().rewardMsg.fontFamily"
      [style.color]="config().rewardMsg.color"
    >
      {{ config().rewardMsg.text }}
    </p>
    <p
      class="reward-amount"
      [style.fontFamily]="config().rewardAmount.fontFamily"
      [style.color]="config().rewardAmount.color"
    >
      <span [innerHTML]="amount() | formatReward | safe"></span>
    </p>

    <p
      class="progress-text"
      [style.fontFamily]="config().progressText.fontFamily"
      [style.color]="config().progressText.color"
    >
      {{ config().progressText.text }}
    </p>
  </div>
</div>
